import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=7ab2328e&scoped=true"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarMenuItem.vue?vue&type=style&index=0&id=7ab2328e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab2328e",
  null
  
)

export default component.exports